import React from "react";
import clsx from "clsx";

import { useChartState } from "../useChartState";
import useStyles from "./styles";

export interface Props {
  title?: React.ReactElement | string;
  value: number;
  capacity: number;
  variant?: "default" | "bold";
  className?: string;
}

const Line = (props: Props) => {
  const { value, capacity, title, variant = "default", className } = props;
  const classes = useStyles();
  const { percent, status } = useChartState(value, capacity);

  return (
    <div className={clsx(classes.lineChartRoot, className)}>
      <div className={clsx(classes.lineChartText, status)}>{title}</div>
      <div
        className={clsx(classes.track, status, {
          [classes.trackExtended]: variant === "bold"
        })}
      >
        <span
          className={clsx(classes.slider, status)}
          style={{ width: `${percent}%` }}
        />
      </div>
    </div>
  );
};

export default Line;
